import { Component } from '@angular/core';

@Component({
  selector: 'df-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.css']
})
export class AddComponent {}
